<template>
    <div class="Psychological_archives">
      <transit :users="UserID"/>
      <div>
        <div style="margin-top: 10px;margin-left: 2%;">
          <el-button v-if="pd" type="primary" @click="gourl()">日常危机上报</el-button>
          <!-- <el-button type="primary" style="margin-right: 40px;">预制表</el-button> -->
          上报类型：
          <el-select size="medium" v-model="Type" placeholder="请选择上报类型" @change="cha()">
            <el-option label="全部" value=""></el-option>
            <el-option label="心理测评" value="1"></el-option>
            <el-option label="日常危机" value="2"></el-option>
            <el-option label="自主上报" value="3"></el-option>
            <el-option label="咨询上报" value="4"></el-option>
            <el-option label="热线上报" value="5"></el-option>
          </el-select>
        </div>

        <el-table :data="tableData" stripe style="width: 96%;margin-left: 2%;margin-top: 20px;">
          <el-table-column label="上报人" width="180">
            <template slot-scope="scope">
              {{ scope.row.RecordName }}
            </template>
          </el-table-column>

          <el-table-column label="上报时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.ReportTime }}
            </template>
          </el-table-column>

          <el-table-column prop="Type" label="上报类型">
            <template slot-scope="scope">
              <span>{{ scope.row.Type }}</span>
              <!-- <span v-if="scope.row.Type == 1">普测</span>
              <span v-else-if="scope.row.Type == 2">日常危机</span>
              <span v-else-if="scope.row.Type == 3">咨询师上报</span>
              <span v-else-if="scope.row.Type == 4">热线上报</span> -->
            </template>
          </el-table-column>

          <el-table-column label="危机状态">
            <template slot-scope="scope">
              <span>{{ scope.row.UrgentStatus }}</span>
            </template>
          </el-table-column>

          <el-table-column label="查看">
            <template slot-scope="scope">
              <span v-if="scope.row.Type == '谈话记录'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_view(scope.row.TalkNo)">查看详情</span>
              <span v-else style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看详情</span>
            </template>
          </el-table-column>
          
        </el-table>

        <el-pagination style="margin-top: 20px;text-align: right" @current-change="handleCurrentChange1" :current-page.sync="pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Count"></el-pagination>

      </div>
    </div>
</template>
<script>
  import transit from './transit'
  export default {
    data(){
      return {
        UserID:'',
        tableData: [],
        pageIndex: 1,
        Type: '',
        Count: 0,
        pd:true
      }
    },
    components: {
      transit,
    },
    methods: {
      gourl() {
        this.$router.push({
          path: '/Crisis/Daily_report',
        })
      },
      Crisis_lookprefabrication(KeyNo, reportStatus, userId) {//查看预制表
        this.$router.push({
          path: '/Crisis/Crisis_lookprefabrication',
          query: { KeyNo: KeyNo, reportStatus: reportStatus, userId: userId },
        })
      },
      Crisis_Memcon_view(TalkNo) {
        this.$router.push({
          path: '/Crisis/Crisis_Memcon_view',
          query: { TalkNo: TalkNo },
        });
      },
      cha() {
        this.load();
      },
      handleCurrentChange1(val) {
        this.pageIndex1 = val;
        this.load();
      },
      load(form) {//列表
        this.$Http_Post('DistressPrediction/StuCrisisReport', { PageIndex: this.pageIndex, PageSize: 10, UserID: this.UserID, Type: this.Type }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
            this.Count = Number(res.Counts);
          }
        })
      },
    },
    mounted() {
      if (this.Global.pdroleid(1071)) {
        this.pd = true;
      } else {
        this.pd = false;
      }
      this.UserID = [this.$route.query.UserID][0];
      this.load();
    }
  }
</script>
<style>
  .Psychological_archives{width: 100%;height: 100%;background-color: #fff;}
  .el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>